import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import MagazinePage from './pages/MagazinePage';
import { getDefaultMagazineId } from './config/magazineConfig';
import { useInstitutionTheme } from './hooks/useInstitutionTheme';

function App() {
  // Inyectar CSS custom properties de la institución y devolver la config
  const institution = useInstitutionTheme();
  const defaultMagazine = getDefaultMagazineId();

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        {/* Página principal - Centro de Publicaciones */}
        <Route exact path="/" component={HomePage} />
        
        {/* Página de categoría - Lista de publicaciones por categoría */}
        <Route exact path="/:categoryId" component={CategoryPage} />
        
        {/* Página de visualización de publicación - categoryId/magazineId */}
        <Route path="/:categoryId/:magazineId" component={MagazinePage} />
        
        {/* Ruta de compatibilidad: redirigir a la revista por defecto */}
        {defaultMagazine && (
          <Route path="/viewer">
            <Redirect to={`/${defaultMagazine.categoryId}/${defaultMagazine.magazineId}`} />
          </Route>
        )}
        
        {/* Ruta 404: redirigir al inicio */}
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;